<template>
  <div class="navbar" ref="navbarRef">
    <div class="logo" @click="jumpIndex" style="cursor: pointer;">
      <img src="@/assets/logos.png" />
      <span>企业端</span>
    </div>
    <el-menu
      :default-active="activeMenu"
      
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
       background-color="rgba(0,0,0,0)"
      text-color="#fff"
      active-text-color="#fff"
    >
              <el-menu-item index="/">
        <img src="@/assets/home2.png" v-if="activeMenu == '/'"/>
         <img src="@/assets/home2s.png" v-else/>
        <span slot="title"
          ><router-link to="/">首页</router-link></span
        >
      </el-menu-item>
          <el-submenu index="2">
        <template slot="title">
          <img src="@/assets/qindex2.png" />
          <span slot="title" style="margin-left: 5px;">人才招聘</span>
        </template>
              <el-menu-item index="/user_indexs">
        <img src="@/assets/home2.png" v-if="activeMenu == '/user_indexs'"/>
         <img src="@/assets/home2s.png" v-else/>
        <span slot="title"
          ><router-link to="/user_indexs">人才招聘首页</router-link></span
        >
      </el-menu-item>
      <el-menu-item index="/user_position">
        <img src="@/assets/111.png" v-if="activeMenu == '/user_position'"/>
        <img src="@/assets/qindex16.png" v-else/>
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/user_position' : ''">职位中心</router-link></span
        >
      </el-menu-item>
      <el-menu-item index="/user_search">
      <img src="@/assets/qindex3.png"  v-if="activeMenu == '/user_search'"/>
        <img src="@/assets/qindex2.png" v-else/>
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/user_search' : ''">搜索人才</router-link></span
        >
      </el-menu-item>
      <!-- <el-menu-item index="3">
        <img src="@/assets/qindex17.png" />
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/user_user_chatchat' : ''">互动</router-link></span
        >
      </el-menu-item> -->
      <el-menu-item index="/user_rencai">
      <img src="@/assets/888.png"  v-if="activeMenu == '/user_rencai'"/>
        <img src="@/assets/qindex14.png" v-else/>
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/user_rencai' : ''">人才管理</router-link></span
        >
      </el-menu-item>
      <el-menu-item index="/user_mianshi">
      <img src="@/assets/666.png" v-if="activeMenu == '/user_mianshi'"/>
        <img src="@/assets/qindex13.png" v-else/>
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/user_mianshi' : ''">面试邀请</router-link></span
        >
      </el-menu-item>
      <el-menu-item index="/user_hr">
      <img src="@/assets/888.png" v-if="activeMenu == '/user_hr'"/>
        <img src="@/assets/qindex14.png"  v-else/>
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/user_hr' : ''">HR管理</router-link></span
        >
      </el-menu-item>
       </el-submenu>
            <el-submenu index="3">
        <template slot="title">
          <img src="@/assets/qindex16.png" />
          <span slot="title" style="margin-left: 5px;">职称评审</span>
        </template>
         <el-menu-item index="/titleReview">
      <img src="@/assets/111.png" v-if="activeMenu == '/titleReview'"/>
        <img src="@/assets/qindex16.png"  v-else/>
        <span slot="title"
          ><router-link :to="Number(exaState) ? '/titleReview' : ''">职称评审</router-link></span
        >
      </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "navbars",
  data() {
    return {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      // exaState:localStorage.getItem('exaState')
    };
  },
  computed:{
    exaState() {
      return this.$store.state.exaState
    },
     activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      let clientHeight = that.$refs.navbarRef.clientHeight;
      that.$store.commit('initClientHeight', clientHeight)
    });
    
  },
  methods: {

    jumpIndex() {
      console.log(this.exaState,88888)
      this.$router.push("/");
    }
  }
};
</script>

<style lang="less" scoped>
a {
  color: #fff;
  height: 100%;
  display: inline-flex;
  width: 100%;
  align-items: center;
}
.navbar img {
  margin-right: 14px;
}
.navbar {
  width: 245px;
  height: 100%;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: #2257AB;
  padding-top: 55px;
}

.navbar .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 105px;
}

.navbar .logo img {
  width: 150px;
  margin-right: 8px;
}

.navbar .logo span {
  display: inline-flex;
  align-items: center;
  padding: 0 13px;
  font-size: 12px;
  color: #ccd4eb;
  height: 19px;
  border-radius: 4px;
  border: 1px solid #ccd4eb;
}
/deep/ .el-menu {
  border-right: none;
}
// /deep/ .el-submenu.is-active {
//   >ul.el-menu {
//     background: rgba(137, 185, 255, 0.44)!important;
//     border-radius: 8px;
//   }
// }
/deep/ .el-menu-item.is-active {
  background-color: #ffffff !important;
  border-radius: 8px;
  a {
    color: #007cc4 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbars1.vue